import { ShippingRate } from "../../../../server/src/contracts/shipping";

export const defaultShipping = {
  estimatedDelivery: "",
  serviceName: "USPS Media Mail",
  serviceType: "usps_media_mail" as ShippingRate["serviceType"],
  price: 5.19,
  displayPrice: "$5.19",
};
